import * as Highcharts from 'highcharts';
import { SeriesLineOptions } from 'highcharts/highcharts';
import { BaseChartProps } from '../types/chartProps';
import { prepareSeriesDataForMultipleYAxis, prepareSeriesDataForSingleYAxis } from './seriesUtils';
import { applyBaseChartOptions } from './baseChartUtils';
import { supportsMultipleYAxis } from './axisUtils';

export function applyLineChartSeriesData(options: Highcharts.Options, params: BaseChartProps) {
  if (supportsMultipleYAxis(params.yAxis)) {
    options.series = prepareSeriesDataForMultipleYAxis<SeriesLineOptions>(params, 'line');
  } else {
    options.series = prepareSeriesDataForSingleYAxis<SeriesLineOptions>(params, 'line');
  }
  return options;
}

export function applyLineChartOptions(options: Highcharts.Options, params: BaseChartProps): Highcharts.Options {
  const fns = [
    applyBaseChartOptions,

    // Line chart specific
    applyLineChartSeriesData
  ];
  return fns.reduce((acc, fn) => fn(acc, params), options);
}
